"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbRadioButtonList = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbRadioButton = require("../sb-radio-button/sb-radio-button");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @typedef skybase-components.sb-radio-button-list#props
 *
 * @property {Array.<Object>} options
 * @property {String|Number} value
 */

/**
 * @name skybase-components.sb-radio-button-list#SbRadioButtonList
 * @function
 *
 * @param  {skybase-components.sb-radio-button-list#props} props
 * @return {React.Component}
 */
var SbRadioButtonList = function SbRadioButtonList(props) {
  var className = props.className,
      onClick = props.onClick,
      direction = props.direction,
      options = props.options,
      value = props.value,
      id = props.id,
      disabled = props.disabled,
      _onChange = props.onChange,
      style = props.style;
  var radioButtons = options.filter(function (option) {
    return !!option.value;
  }).map(function (option) {
    var optionValue = option.value,
        description = option.description,
        label = option.label,
        optionId = option.id,
        optionClassName = option.className,
        optionStyle = option.style,
        onOptionClick = option.onClick,
        restOption = _objectWithoutProperties(option, ["value", "description", "label", "id", "className", "style", "onClick"]);

    return /*#__PURE__*/_react.default.createElement(_sbRadioButton.SbRadioButton, _extends({}, restOption, {
      className: optionClassName,
      id: optionId,
      key: "".concat(id, "-radio-button-list-").concat(optionValue),
      checked: optionValue === value,
      disabled: disabled,
      onClick: onOptionClick || onClick,
      onChange: function onChange() {
        return _onChange(optionValue);
      },
      style: optionStyle,
      value: optionValue
    }), description || label);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _classnames.default)((0, _utils.getDirectionClass)(direction), className),
    style: style
  }, radioButtons);
};

exports.SbRadioButtonList = SbRadioButtonList;
SbRadioButtonList.propTypes = {
  className: _propTypes.default.string,
  direction: _propTypes.default.oneOf([_constants.enumDirection.HORIZONTAL, _constants.enumDirection.VERTICAL]),
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    description: _propTypes.default.string,
    label: _propTypes.default.string,
    id: _propTypes.default.string,
    className: _propTypes.default.string,
    style: _propTypes.default.object
  })),
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object // eslint-disable-line

};
SbRadioButtonList.defaultProps = {
  className: null,
  direction: _constants.enumDirection.HORIZONTAL,
  disabled: false,
  id: null,
  options: [],
  value: null,
  onChange: function onChange() {},
  onClick: null,
  style: null
};
//# sourceMappingURL=sb-radio-button-list.js.map